import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'cloudinary-react';
import { DateTime } from 'luxon';
import { css } from '@emotion/core';

import Markdown from 'common/markdown';
import Link from 'common/link';

const multilineTruncate = css`
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 3em;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const BlogCard = ({ title, slug, featureImage, excerpt, category, publishedAt }) => {
    const formattedDate = DateTime.fromISO(publishedAt).toLocaleString(DateTime.DATE_FULL);
    const url = `/blog/post/${slug}`;

    return (
        <div className="lg:flex items-center bg-white border border-gray-light">
            <div className="lg:w-1/2 relative self-stretch">
                {/* Sets a nice comfortable min-height for the image */}
                <div className="aspect-ratio-card w-full bg-gray-lighter" />
                {featureImage && (
                    <Link to={url}>
                        <Image
                            publicId={featureImage.id}
                            alt=""
                            className="block w-full h-full object-center object-cover absolute pin"
                            transformation="blog-card"
                        />
                    </Link>
                )}
            </div>
            <div className="lg:w-1/2 p-8 lg:p-12 self-center">
                <h2 className="font-black text-21 lg:text-24 leading-snug">
                    <Link to={url} className="text-gray-90 hover:text-gray-50">
                        {title}
                    </Link>
                </h2>
                <p className="mt-6 text-gray-40 font-bold uppercase tracking-wide text-14">
                    {formattedDate} &bull; {category}
                </p>
                <div className="text-16 leading-relaxed text-gray-70 mt-6">
                    {excerpt && (
                        <Markdown className="overflow-hidden" css={multilineTruncate}>
                            {excerpt}
                        </Markdown>
                    )}
                    <p className="mt-4">
                        <Link to={url} className="link-green font-bold">
                            Read more
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

BlogCard.propTypes = {
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    publishedAt: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    excerpt: PropTypes.string,
    featureImage: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }),
};

BlogCard.defaultProps = {
    excerpt: null,
    featureImage: null,
};

export default BlogCard;
